<fieldset class="otp-fieldset" [disabled]="disabled">
  <legend class="field-label">Código de confirmação</legend>

  <div class="otp-cells" [class.invalid]="invalid" [class.success]="success" (paste)="onPaste($event)">
    <input
      *ngFor="let i of indices; trackBy: trackByIndex"
      #cell
      type="text"
      inputmode="numeric"
      pattern="[0-9]*"
      maxlength="1"
      autocomplete="one-time-code"
      class="otp-cell"
      [class.invalid]="invalid"
      [class.success]="success"
      [attr.aria-label]="'Dígito ' + (i + 1) + ' de ' + length"
      [attr.aria-invalid]="invalid ? 'true' : null"
      [value]="digits[i]"
      [disabled]="disabled"
      (input)="onInput($event, i)"
      (keydown)="onKeydown($event, i)"
    />
  </div>
</fieldset>
